export enum QuoteSteps {
  intro = 'intro',
  carDetails = 'car-details',
  chargingStationDetails = 'charging-station-details',
  technicalDetails = 'technical-details',
  houseDetails = 'house-details',
  personalDetails = 'personal-details',
  confirmation = 'confirmation',
}

export const quoteStepsOrder = [
  {
    step: QuoteSteps.carDetails,
    stepProgressIcon: '/assets/evc/img/progress-icons/carDetails.svg',
    description: 'modules.evcQuote.steps.intro.steps.step1',
  },
  {
    step: QuoteSteps.chargingStationDetails,
    stepProgressIcon: '/assets/evc/img/progress-icons/chargingStationDetails.svg',
    description: 'modules.evcQuote.steps.intro.steps.step2',
  },
  {
    step: QuoteSteps.technicalDetails,
    stepProgressIcon: '/assets/evc/img/progress-icons/technicalDetails.svg',
    description: 'modules.evcQuote.steps.intro.steps.step3',
  },
  {
    step: QuoteSteps.houseDetails,
    stepProgressIcon: '/assets/evc/img/progress-icons/houseDetails.svg',
    description: 'modules.evcQuote.steps.houseDetails.stepName',
  },
  {
    step: QuoteSteps.personalDetails,
    stepProgressIcon: '/assets/evc/img/progress-icons/personalDetails.svg',
    description: 'modules.evcQuote.steps.intro.steps.step5',
  },
];
